"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreInteractiveIcon = _interopRequireDefault(require("@vfuk/core-interactive-icon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var PaginatorArrow = function PaginatorArrow(_ref) {
  var direction = _ref.direction,
    _onClick = _ref.onClick,
    isDisabled = _ref.isDisabled,
    goToPage = _ref.goToPage,
    t = _ref.t;
  var text = direction === 'left' ? t('Go to the previous page') : t('Go to the next page');
  return /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
    appearance: "primary",
    state: isDisabled ? 'disabled' : undefined,
    name: "chevron-".concat(direction),
    onClick: function onClick(event) {
      _onClick(event, goToPage);
    },
    size: 2,
    srText: text
  });
};
PaginatorArrow.displayName = "PaginatorArrow";
var _default = PaginatorArrow;
exports["default"] = _default;